import { getRandomNumbers } from './getRandomNumbers';
import reporter from './report';

const userInputInfoMap = new Map<string, { inputTime: number; inputType: InputType }>();

export enum OutputType {
  Default = 'Default',
  DocQAFail = 'DocQAFail',
  DocQADelay = 'DocQADelay',
  DocQAOverLength = 'DocQAOverLength',
  DocQASuccess = 'DocQASuccess',
}

export enum InputType {
  Type = 'type',
  CLick = 'click',
}

export function addUserInputInfo(inputType = InputType.CLick) {
  const userInputId = getRandomNumbers();
  userInputInfoMap.set(userInputId, {
    inputTime: Date.now(),
    inputType,
  });
  return userInputId;
}

export function reportReplyTimeCost(props?: any) {
  const userInputId = props?.userInputId;
  if (!userInputId) {
    return;
  }

  const userInputInfo = userInputInfoMap.get(userInputId);
  if (!userInputInfo) {
    return;
  }

  const { inputTime, inputType } = userInputInfo;
  const { outputType } = props;

  reporter.apiBatchReport({
    type: 'time',
    value: {
      label: 'chatbot_reply_time_cost',
      cost: Date.now() - inputTime,
      extend_1: inputType,
      extend_2: outputType?.join?.() || OutputType.Default,
    },
  });
  userInputInfoMap.delete(userInputId);
}
